// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"385":"dc1182cd","911":"3301f2fd"}[chunkId] + ".chunk.css";
};